import React from 'react'
import Mynav from '../../components/Header/Header'
import { Container, Col, Row } from 'react-bootstrap'

import myimg from '../../assets/hairStyle.png'
import './about.css'
import about from '../../assets/img/app.png'

import video from '../../assets/img/sarah.png'
import SEO from '../../components/SEO'
const About = () => {
  return (
    <>
      {/* <Container className='py-2'></Container> */}
    <Container fluid>

    <SEO title="About US" description="Welcome to Sarah Adom Braiding Salon, where beauty, culture, and community come together to create a space of empowerment and self-expression." />

    <div className='p-5 text-center bg-image fluid'
        style={{ backgroundImage: `url(${about})`, height: 600, backgroundRepeat: "no-repeat" , backgroundPosition: 'center',
        backgroundSize: 'cover'}}>
        <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div className='text-white py-3'>
              <h1 className='mb-3'>ABOUT US</h1>
              <p className='mb-3'>Our Story - Mission </p>
              {/* <a className='btn btn-outline-light btn-lg' href='#!' role='button'>
                Call to action
              </a> */}
            </div>
          </div>
        </div>
        </div>

        </Container>

        <Container>

<Row>
        <Col sm={4} className='mr-5'>
          
          {/* <img src={myimg} className='about-img mt-4' /> */}
        
        {/* <iframe> src={video}</iframe> */}
<div className='spacer'></div>
       
    
        
        <img src={video} width="400px" />
        </Col>
        <Col sm={8}>


<div className="p text-justify py-5 mt-5">

  <h2 className='h3  text-center'>Sarah Adom Braiding Salon </h2>

<p className='py-1 text-wrap text-break about-desc'>Welcome to Sarah Adam Braiding Salon, your premier destination for professional African hair braiding in Manassas, Virginia. With a passion for beauty and a commitment to healthy hair care, we specialize in a wide variety of braiding styles that not only enhance your natural beauty but also protect and nourish your hair.

At Sarah Adam Braiding Salon, we offer a diverse range of styles, including box braids, Senegalese twists, cornrows, crochet braids, goddess braids, and much more. Whether you're looking for a classic, timeless look or something more modern and trendy, our team of skilled braiders will work with you to create the perfect style that suits your personality and lifestyle.

We pride ourselves on delivering quality service in a welcoming, professional environment. Each member of our team is highly trained and experienced in the latest braiding techniques, ensuring that you leave our salon looking and feeling your best. We prioritize customer satisfaction and take the time to understand your hair needs, offering personalized consultations and expert recommendations for maintaining your braids.

At Sarah Adam Braiding Salon, we believe in the power of self-expression through hair, and we are dedicated to making sure every client walks out with a hairstyle they love. We are committed to providing styles that are not only beautiful but also protective, helping you maintain the health and strength of your natural hair.

Visit us today in Manassas, VA, and let us help you achieve the style you’ve always dreamed of. We look forward to making your braiding experience exceptional.</p>

</div>


        </Col>
      </Row>


    </Container>
 

   </>
  )
}

export default About
